import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import BreadcrumbsItemModuleCss from './BreadcrumbsItem.module.css';
import { LocalizedText } from '~/components/LocalizedText/LocalizedText';
import { LocalizationItem } from '~/constants/LocalizationItem';
import type { SiteMapItem } from '~/models/siteMap';

const block = bemCssModules(BreadcrumbsItemModuleCss);

export const Breadcrumb: VFC<SiteMapItem> = ({ Path, Title }) => {
  const location = useLocation();
  const isActiveModifier = location.pathname === Path;

  const getBreadcrumbType = () => {
    if (Title === LocalizationItem.Search || Title === LocalizationItem.SupportCenter) {
      return <LocalizedText localizationItem={LocalizationItem[Title]} />;
    }

    return Title;
  };

  if (isActiveModifier) {
    return <span className={block({ 'is-active': isActiveModifier })}>{getBreadcrumbType()}</span>;
  }

  return (
    <Link
      className={block()}
      to={Path}
    >
      <span className={block('name')}>{getBreadcrumbType()}</span>
    </Link>
  );
};
